import axios from '../../http/axios/index.js';
import { toAuthorizationHeader } from '@/utils/localStorageHelpers';

export default {
  SET_BEARER(state, accessToken) {
    const authorization = toAuthorizationHeader(accessToken);
    if (authorization) {
      axios.defaults.headers.common['Authorization'] = authorization;
    }
  },
  UPDATE_POPUP(state, show) {
    state.showPopup = show;
  },
  UPDATE_POPUP_FLAG(state, show) {
    state.popupFlag = show;
  },
};
